import Swiper from "swiper";
import {Navigation, Pagination } from "swiper/modules"

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

window.Swiper = Swiper;
window.Swiper_Navigation = Navigation;
window.Swiper_Pagination = Pagination;